export interface KeyDateRequest {
    contractNotesID?: number;
    contractNotesAmount?: any;
    entryDate: string;
    contractType: KeyDateTypes;
    contractNotes: string;
    contractRefNum?: string;
    contractNotesOther?: string;

    contractNotesCurrency?: string;
}

export interface KeyDateResponse extends Required<KeyDateRequest> {
    contractRefNum: string;
    contractClause: string;
}

export interface RoyaltyRateRequest {
    contractRateID?: number;
    contractRateRate: number;
    contractRateRegion?: any;
    contractRateFormat: string;
    // customInput?: string;
}

export interface RoyaltyRateResponse extends Required<RoyaltyRateRequest> {
    contractRefNum: string;
}

export interface RecoupableRequest {
    contractRecoupID?: number;
    contractRecoupCode: string;
    contractRecoupRegion?: any;
    contractRecoupRate: number;
}

export interface contractSubTypeList {
    accStatusExtUseId: number;
    accStatusUseId: number;
    contractRefNum: string;
    contractSubTypeID: number;
    freeText: string;
}
export interface RecoupableResponse extends Required<RecoupableRequest> {
    contractRefNum: string;
}

export enum KeyDateTypes {
    ADVANCE = 1,
    RETENTION,
    AUDIT,
    OPTION,
    GENERAL,
    OTHER,
    ACQUISITION,
}

export enum AccountingTerm {
    NULL,
    MONTHLY,
    QUARTERLY,
    BI_ANNUAL,
    YEARLY,
}
